import { render, staticRenderFns } from "./game.vue?vue&type=template&id=17e8334b&scoped=true&"
import script from "./game.vue?vue&type=script&lang=js&"
export * from "./game.vue?vue&type=script&lang=js&"
import style0 from "@/sass/game.scss?vue&type=style&index=0&id=17e8334b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e8334b",
  null
  
)

export default component.exports